import { Button, Collapse, Modal, Space, Spin, Tooltip, message } from "antd";
import { PlusIcon, EditIcon, TrashIcon } from "../../admin/Icons";
import { RedoOutlined, CopyOutlined } from '@ant-design/icons';
import Overlay from "../Overlay";
import wrap from "../../utils/wrap";
import { canDeleteRecord, tt_link_delete, tt_link_duplicate, tt_link_reset, tt_links_edit } from "../../utils/Utils";
import { usePrefs } from "../../utils/Prefs";
import LinkStyle from "./LinkStyle";
import { useState } from "react";

export default function LinkStyles(props) {

    const { templates = [], data = {}, changed = false, view = "", setData = () => { } } = props;
    const [prefs, setPrefs] = usePrefs();

    // Used to temporarily undraw the UI so resetting sets the default values on uncontrolled UI
    const [hide, setHide] = useState(null);

    const default_link = {
        name: "Unnamed Link",
        init_colour: 0,
        init_style: 3,
        init_underline: false,
        hover_colour: 0,
        hover_style: 3,
        hover_underline: true,
    }
    // Save name and default link object
    const saveNew = (_name, _obj) => {
        _obj.name = _name;
        _obj.id = data.links.length + 1;
        let _links = [...data.links];
        _links.push(_obj);
        setData({ ...data, "links": _links });
        setPrefs({ ...prefs, "changed": true, "link_index": _obj.id });
    }

    // Save a field in a link (deep object save)
    const save = (_id, _value, _keys = [], _new = false) => {
        let _links = [...data.links];
        let _index = _links.findIndex(item => item.id === _id)
        // instance found
        if (_index > -1) {
            _links[_index][_keys[0]] = _value;
            setData({ ...data, "links": _links });
            setPrefs({ ...prefs, "changed": true })
        }
    }

    // Remove Link
    const remove = (e, _id) => {
        e.stopPropagation();
        e.preventDefault();
        Modal.confirm({
            title: "Delete?",
            onOk: () => {
                let _links = data.links.filter(item => item.id !== _id);
                setData({ ...data, "links": _links });
                setPrefs({ ...prefs, "changed": true });
            }
        })
    }

  
    // Reset Link
    const reset = (e, _id) => {


        e.stopPropagation();
        e.preventDefault();
        Modal.confirm({
            title: "Reset?",
            onOk: () => {
                setHide(_id);
                let _links = [...data.links];
                let _f = _links.findIndex(item => item.id === _id);
                if (_f > -1) {

                    _links[_f] = { ...default_link, "id": _id }
                    console.log(_links[_f]);
                } else {
                    message.error("There was an error");
                }
                setData({ ...data, "links": _links });
                setPrefs({ ...prefs, "changed": true });
                setTimeout(() => {
                    setHide(null)
                }, 100)
            }
        })
    }

    // Duplicate Link
    const duplicate = (e, _obj) => {
        e.stopPropagation();
        e.preventDefault();
        Modal.confirm({
            title: "Duplicate?",
            onOk: () => {
                _obj.name = _obj.name + " (copy)";
                _obj.id = data.links.length + 1;
                let _links = [...data.links];
                _links.push(_obj);
                setData({ ...data, "links": _links });
                setPrefs({ ...prefs, "changed": true, "link_index": _obj.id });
            }
        })
    }

    // Draw header
    const drawHeader = () => {
        return (
            <Overlay width="320px" component={<LinkStyle default_link={default_link} saveNew={saveNew} save={save} is_new links={data.links} />}><wrap.tags color="#1890ff"><PlusIcon />&nbsp;<small>New</small></wrap.tags></Overlay>
        )
    }

    // Draw link list
    const drawLinks = () => {
        return (
            <div>
                <Collapse accordion onChange={(e) => setPrefs({ ...prefs, "link_index": e })} activeKey={prefs.link_index} className="subpanel" expandIcon={({ isActive }) => {
                    return (isActive) ? "-" : "+"
                }} ghost>
                    {data.links.map(item => {

                        if(hide === item.id){
                            return(<></>)
                        }

                        let name = (item.hasOwnProperty("name")) ? item.name : ""
                        let can_delete = canDeleteRecord(templates, data, item.id, "links", "Unnamed Link");
                        return (
                            <Collapse.Panel header={
                                <div className="float-flex">
                                    <div style={{ "color": "#e77e21", "fontSize": "11px" }}>{name.toUpperCase()}</div>
                                    <Space size={0}>
                                        <Tooltip title={tt_link_duplicate}><Button onClick={(e) => duplicate(e, { ...item })} type="link" icon={<CopyOutlined />} size="small" /></Tooltip>
                                        {(!can_delete && <Tooltip title={tt_link_delete}><Button onClick={(e) => reset(e, item.id)} type="link" icon={<RedoOutlined />} size="small" /></Tooltip>)}
                                        {(can_delete && <Tooltip title={tt_link_reset}><Button onClick={(e) => remove(e, item.id)} type="link" icon={<TrashIcon />} size="small" /></Tooltip>)}
                                        <Overlay width="320px" component={<LinkStyle default_link={default_link} saveNew={saveNew} save={save} is_edit id={item.id} link={item} links={data.links} />}>
                                            <Tooltip title={tt_links_edit}><Button type="link" icon={<EditIcon />} size="small" /></Tooltip>
                                        </Overlay>
                                    </Space>
                                </div>

                            } key={item.id}>

                                <LinkStyle default_link={default_link} saveNew={saveNew} save={save} data={data} link={item} links={data.links} />

                            </Collapse.Panel>
                        )
                    })}
                </Collapse>
            </div>
        )
    }

    switch (view) {
        case "header":
            return drawHeader();
        default:
            return drawLinks();
    }

}

